import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useLeadStats } from "@/hooks/use-lead-stats";
import { summarizeByUser, weekStart } from "@/lib/lead-stats-calc";
import { osloDateString } from "@/lib/oslo-time";

/** Møtebookerens egne tall øverst i Leads-fanen: samtaler i dag og møter booket denne uken. Bare tall, ingen mål (parkert). */
export default function MotebookerProgress() {
  const { activeUser } = useImpersonation();
  const now = new Date();
  const today = osloDateString(now);
  const week = { fromDate: weekStart(today), toDate: today };
  const { data: rows } = useLeadStats(week, { now });
  const mine = summarizeByUser((rows ?? []).filter((r) => r.user_id === activeUser?.id), now, week)[0];

  return (
    <section aria-label="Dine tall" className="grid grid-cols-2 gap-px border-[1.5px] border-foreground bg-foreground">
      <div className="bg-card p-4">
        <p className="text-xs text-muted-foreground">Samtaler i dag</p>
        <p className="font-display text-3xl font-semibold tabular-nums">{mine?.today.calls ?? 0}</p>
      </div>
      <div className="bg-card p-4">
        <p className="text-xs text-muted-foreground">Møter booket denne uken</p>
        <p className="font-display text-3xl font-semibold tabular-nums">{mine?.week.meetings_booked ?? 0}</p>
      </div>
    </section>
  );
}
